export const memberSourceworkflow = {
    GPO: {
     required : true
    },
    "Home Medical Equipment": {
      required: true
    },
    "Medical Distributor": {
      required: true
    },
    "Alt Site": {
      required : true
    },
    "LTC Network": {
      required : true
    },
    // "HME": {
    //   ControlName : "Alt",
    //   Condition : "TaxIdNonMandatory",
    //   showVendor : "Allowed"
    // },
  };